const SonkoJobsIndex = () => import('./index.vue')
const CreateJobPage = () => import('./_pages/create_job')
const SonkoJobDetails = () => import('./_pages/details')
const ProjectDetails = () => import('./_pages/project')
const Engagements = () => import('./_pages/engagements')
const Assigned = () => import('./_pages/assigned')
import { CheckSonkoGuard } from '@/common/guard'

export default [
    { 
        path: '/sonko/jobs/:status',
        beforeEnter: CheckSonkoGuard,
        component: SonkoJobsIndex,
        name: 'SonkoJobsIndex'
    },
    { 
        path: '/sonko/job/details/:id',
        beforeEnter: CheckSonkoGuard,
        component: SonkoJobDetails,
        name: 'SonkoJobDetails'
    },
    { 
        path: '/sonko/project/details/:id',
        beforeEnter: CheckSonkoGuard,
        component: ProjectDetails,
        name: 'SonkoProjectDetails'
    },
    { 
        path: '/sonko/job/engagements/:id',
        beforeEnter: CheckSonkoGuard,
        component: Engagements,
        name: 'Engagements'
    },
    { 
        path: '/sonko/job/assigned/:id',
        beforeEnter: CheckSonkoGuard,
        component: Assigned,
        name: 'Assigned'
    },
    {
        path: '/sonko/create/job',
        beforeEnter: CheckSonkoGuard,
        component: CreateJobPage,
        name: 'CreateJobPage'
    }
]